"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertStudioFromFittec = convertStudioFromFittec;
function convertStudioFromFittec(studio) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var addrSrc = (_a = studio.address) !== null && _a !== void 0 ? _a : {};
    var mainImage = (_b = studio.assets) === null || _b === void 0 ? void 0 : _b.mainImage;
    var studioImage = mainImage && 'publication' in mainImage ? (_c = mainImage.publication) === null || _c === void 0 ? void 0 : _c.publicUrl : undefined;
    var address = {
        street: (_d = addrSrc.street) !== null && _d !== void 0 ? _d : '',
        secondStreet: null,
        cityPart: null,
        district: null,
        city: (_e = addrSrc.city) !== null && _e !== void 0 ? _e : '',
        zipCode: (_f = addrSrc.postalCode) !== null && _f !== void 0 ? _f : '',
        houseNumber: (_g = addrSrc.houseNumber) !== null && _g !== void 0 ? _g : '',
        countryCode: (_h = addrSrc.countryCode) !== null && _h !== void 0 ? _h : '',
        countryCodeAlpha2: (_j = addrSrc.countryCode) !== null && _j !== void 0 ? _j : '',
        longitude: typeof addrSrc.longitude === 'number' ? addrSrc.longitude : 0,
        latitude: typeof addrSrc.latitude === 'number' ? addrSrc.latitude : 0,
        streetType: null,
        streetBlock: null,
        portal: null,
        stairway: null,
        door: null,
        floor: null,
        province: null,
        additionalAddressInformation: null,
        streetAddition: null,
        buildingName: null,
    };
    var weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    var openingHours = weekdays.flatMap(function (day) {
        var _a, _b;
        return ((_b = (_a = studio.openingHours) === null || _a === void 0 ? void 0 : _a[day]) !== null && _b !== void 0 ? _b : []).map(function (timespan) {
            var _a = timespan.split('-'), timeFrom = _a[0], timeTo = _a[1];
            return {
                dayOfWeekFrom: day.toUpperCase(),
                dayOfWeekTo: day.toUpperCase(),
                timeFrom: timeFrom,
                timeTo: timeTo,
            };
        });
    });
    var mlProvider = ((_k = studio.provider) === null || _k === void 0 ? void 0 : _k.name) === 'magicline' ? studio.provider : undefined;
    var studioTags = ((_l = mlProvider === null || mlProvider === void 0 ? void 0 : mlProvider.tags) !== null && _l !== void 0 ? _l : []).map(function (t) { return ({
        name: t.name,
        identifier: t.identifier,
    }); });
    var id = 0;
    var yondStudioOid;
    var yondLegalEntitiyOid;
    var yondLegalEntityName;
    var yondAGBUrl;
    if (studio.provider && 'studioId' in studio.provider) {
        id = studio.provider.studioId;
    }
    // yond
    if (studio.provider && 'id' in studio.provider) {
        id = studio.provider.id;
    }
    // if (studio.provider?.name === 'magicline') {
    //   id = studio.provider?.studioId;
    // } else if (studio.provider?.name === 'yond') {
    //   id = studio.provider?.id ?? ('' as any);
    // } else {
    //   id = studio.studioId as any; // have to allow string ids sadly
    // }
    if (((_m = studio.provider) === null || _m === void 0 ? void 0 : _m.name) === 'yond') {
        yondStudioOid = (_o = studio.provider) === null || _o === void 0 ? void 0 : _o.studioOid;
        yondLegalEntitiyOid = (_p = studio.provider) === null || _p === void 0 ? void 0 : _p.legalEntityOid;
        yondLegalEntityName = (_q = studio.provider) === null || _q === void 0 ? void 0 : _q.legalEntityName;
        yondAGBUrl = (_r = studio.provider) === null || _r === void 0 ? void 0 : _r.agbUrl;
    }
    var openingDate = studio.openingDate ? new Date(studio.openingDate) : null;
    var closingDate = studio.closingDate ? new Date(studio.closingDate) : null;
    var out = {
        id: id,
        firestoreDocId: studio.id,
        studioName: studio.name,
        studioImage: studioImage,
        studioPhone: (_s = studio.phone) !== null && _s !== void 0 ? _s : '',
        studioEmail: (_t = studio.email) !== null && _t !== void 0 ? _t : '',
        trialSessionBookable: (_u = studio.trialSessionBookable) !== null && _u !== void 0 ? _u : false,
        address: address,
        studioTags: studioTags,
        masterStudioId: null,
        openingDate: openingDate,
        closingDate: closingDate,
        openingHours: openingHours,
        zoneId: (_v = studio.timezone) !== null && _v !== void 0 ? _v : '',
        hasRateBundles: true,
        trialSessionName: (_w = studio.trialSessionName) !== null && _w !== void 0 ? _w : null,
        currencyCode: (_x = studio.currencyCode) !== null && _x !== void 0 ? _x : '',
        // optional/extras:
        tenantId: studio.tenantId,
        yondStudioOid: yondStudioOid,
        yondLegalEntitiyOid: yondLegalEntitiyOid,
        yondLegalEntityName: yondLegalEntityName,
        yondAGBUrl: yondAGBUrl,
        // distanceToUser, redirect left undefined by design
    };
    return out;
}
